export const GAME_CONSTANTS = {
    MAX_YEARS: 10,
    STARTING_BALANCE: 2000,
    PLAYER_NAME: 'Player'
};